import 'babel-polyfill'
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import configureStore, { history } from './store/configureStore'
import { ConnectedRouter } from 'react-router-redux'
import App from './components/App'


export const store = configureStore()

ReactDOM.render(
    (
        <Provider store={store}>
            <ConnectedRouter history={history}>
                <App />
            </ConnectedRouter>
        </Provider>
    ),
    document.getElementById('root')
)
